import state from './state.auth'
import getters from './getters.auth'
import mutations from './mutations.auth'
import actions from './actions.auth'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}